// extracted by mini-css-extract-plugin
export default {"balance":"balance--3OhzB","left":"left--2APFm","balanceRange":"balanceRange--3EY9h","right":"right--125Rz"};